import { GlobalLocation } from "../../../application/GeoLocation";
export class IsEuMemberQualifier {
    constructor() {
        this.key = "IsEuMember";
    }
    process() {
        const isEu = GlobalLocation.getIsEuMember();
        if (isEu === undefined || isEu === null) {
            return "false";
        }
        return isEu.toString().toLowerCase();
    }
}
